module.exports = __webpack_public_path__ + "img/Scotland.5983d8e6.svg";